<ng-container *ngIf="scorecards.length">
  <div class="preview-scorecards-container container">
    <h2 class="badge-carousel-subheading my-0">
      {{ 'fgbcl.preview.scorecard.title' | translate: { fgbdefault: 'Challenges' } }}
    </h2>
    <div class="badge-description">
      {{
        'fgbcl.preview.scorecard.description'
          | translate
            : {
                fgbdefault:
                  'Step up and test your skills with our exciting Challenges. Each challenge offers opportunities to earn rewards,
      unlock badges, and celebrate your progress along the way. Are you ready to take on the challenge?',
              }
      }}
    </div>

    <owl-carousel-o [options]="customOptions()">
      <ng-container *ngFor="let scorecard of scorecards">
        <ng-template carouselSlide [width]="scorecards.length <= 2 ? itemWidth : 0">
          <div class="overlay">
            <div class="scorecard-container scorecard-preview scorecard rounded-4">
              <img
                class="scorecard-preview-image"
                src="{{ scorecard.Image | contentImage: '7' : 'badge' }}"
                [useDefault]="true"
                [loyaltyType]="'badge'"
              />
              <h3 class="scorecard-name scorecard-label-ellipsis" id="scorecard-preview-name">
                {{ scorecard.Content[0].Name }}
              </h3>
              <div class="scorecard-preview-prize">
                <label class="scorecard-preview-prize-label scorecard-label-ellipsis">{{ 'scorecard.prize' | translate }} </label>
                <span class="scorecard-preview-prize-text" id="scorecard-completed-text">{{
                  scorecard.Content[0].PrizeDescription
                }}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</ng-container>
